import { createContext, useContext, useState } from "react";

const TrackingContext = createContext();

export const TrackingProvider = ({ children }) => {
  const [eventId, setEventId] = useState(null);

  return (
    <TrackingContext.Provider value={{ eventId, setEventId }}>
      {children}
    </TrackingContext.Provider>
  );
};

export const useTrackingContext = () => useContext(TrackingContext);
